export const INTOP_PLANET_FACTURA = {
  account: '20208000107006469001',
  accountant: 'TASHBAYEV JAXONGIR NURULLAYEVICH',
  address: "Ziyokor MFY, Universitet ko'chasi, 2/1-uy  ",
  director: 'TASHBAYEV JAXONGIR NURULLAYEVICH',
  directorPinfl: 51210016500014,
  directorTin: '578606961',
  isBudget: 0,
  isItd: false,
  mfo: '01071',
  na1Code: 12,
  na1Name: 'Масъулияти чекланган жамият',
  name: '"INTOP PLANET" MAS\'ULIYATI CHEKLANGAN JAMIYAT',
  ns10Code: 26,
  ns11Code: 9,
  oked: '62090',
  peasantFarm: false,
  personalNum: null,
  privateNotary: false,
  selfEmployment: false,
  shortName: '"INTOP PLANET" MCHJ',
  statusCode: 0,
  statusName: 'Фаолият кўрсатаётган ва солиқ мажбуриятига эга',
  tin: '311053656',
  status: {
    active: false,
    isSafe: true,
    suspended: false,
    vatPayer: false,
    vatRegCode: '',
  },
  taxpayer: {
    code: 30,
    name: 'Aйланмадан солиқ тўловчи',
    nameRu: 'Плательщик налога с оборота',
    nameUz: 'Aylanmadan soliq to‘lovchi',
  },
  facturaId: '',
  facturaProductId: '',
  product: null,
  has_branch: 0,
};

export const EXPRESS_MAIL_UNIVERSAL_FACTURA = {
  account: '20208000400689770001',
  accountant: 'JUMAYEV MUROD G‘AFUROVICH',
  address: "Hamid Sulaymon MFY, Shota Rustaveli ko'chasi, 37/14-uy  ",
  director: 'JUMAYEV MUROD G‘AFUROVICH',
  directorPinfl: 33103861100028,
  directorTin: '505140845',
  isBudget: 0,
  isItd: false,
  mfo: '00083',
  na1Code: 12,
  na1Name: 'Масъулияти чекланган жамият',
  name: '"EXPRESS MAIL UNIVERSAL" MAS\'ULIYATI CHEKLANGAN JAMIYAT',
  ns10Code: 26,
  ns11Code: 4,
  oked: '53200',
  peasantFarm: false,
  personalNum: null,
  privateNotary: false,
  selfEmployment: false,
  shortName: '"EXPRESS MAIL UNIVERSAL" MCHJ',
  statusCode: 0,
  statusName: 'Фаолият кўрсатаётган ва солиқ мажбуриятига эга',
  tin: '304410214',
  status: {
    active: true,
    isSafe: true,
    suspended: false,
    vatPayer: true,
    vatRegCode: '326040058509',
  },
  taxpayer: {
    code: 20,
    name: 'ҚҚС тўловчи+ (гувоҳнома фаол)',
    nameRu: 'Плательщик НДС+ (сертификат активный)',
    nameUz: 'QQS to‘lovchi+ (guvohnoma faol)',
  },
  facturaId: '',
  facturaProductId: '',
  product: null,
  has_branch: 0,
};

export const EXPRESS_MAIL_UNIVERSAL_WAREHOUSE = {
  FullName: 'ALIMOV BOTIR BAXROMOVICH',
  Pinfl: '31205870230063',
  DistrictCode: 4,
  DistrictName: 'Зангиатинский район',
  Latitude: 41.216589,
  Longitude: 69.173304,
  MahallaId: null,
  MahallaName: null,
  Address: 'Амира Темура, 2-А',
  RegionId: 27,
  RegionName: 'Ташкентская область',
};
